<template>
  <div class="yx-bdqk-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 学生信息登记 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <!-- <div class="opt-btn" title="导出" @click="exportExcel">
            <i
              class="iconfont icon-daochu3"
              :class="{ disabled: isExport }"
            ></i>
          </div> -->
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
  </div>
</template>
  
  <script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/infoRecords";
import { getOrgOptions } from "@/libs/searchSelect";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-forecast/statistics/studentFormListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    idCard: "",
    studentName: "",
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    academicDegree: "",
    classIdList: [],
    noCompleteLinkIdList: [],
  },
  pageExportPath: "",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      isExport: false, // 是否导出
      message: null,
    };
  },
  computed: {
    ...mapState("dic", [
      "_CURRENTYEAR",
      "SUCCESS_CODE",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
    this.getColumns();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    //获取表头
    getColumns() {
      this.$http
        .get("/account/base/student/config/listAll")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            res.data.forEach((item) => {
              this.tableColumns.push({
                label: item.name,
                prop: "map." + item.id,
                align: "center",
                minWidth: 140,
                show: true,
              });
              this.searchItems[this.searchItems.length - 1].options.push({
                label: item.name,
                value: item.type,
              });
            });
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    search() {
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      params.noCompleteLinkId = params.noCompleteLinkIdList.join(",");
      delete params.noCompleteLinkIdList;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.pageParams = {
        idCard: "",
        studentName: "",
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        academicDegree: "",
        classIdList: [],
        noCompleteLinkIdList: [],
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        this.pageExportParams.classId =
          this.pageExportParams.classIdList.join(",");
        delete this.pageExportParams.classIdList;
        this.pageExportParams.noCompleteLinkId =
          this.pageExportParams.noCompleteLinkIdList.join(",");
        delete this.pageExportParams.noCompleteLinkIdList;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
  },
};
</script>
  